import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import cfe from "../../../services/cfe";
import ActionTable from "../../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { mergeParams } from "../../../helpers/helpers";
import AppContext from "../../../container/context";

export default function Lista({ history, location }) {
  const [dados, setDados] = useState(
    mergeParams(
      {
        nome: "",
      },
      location
    )
  );
  const [instituicoes, setInstituicoes] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarInstituicao();
  }, []);

  const carregarInstituicao = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);

    cfe
      .get("admin/instituicoes/listar", filtrosEnviar)
      .then((res) => {
        setInstituicoes(res);
        setCarregando(false);
      })
      .catch((e) => notification("error", "Erro ao listar os intituições"));
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: dados.nome,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarInstituicao,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Intituições",
    newItemAction: () => history.push("/app/cfe-instituicoes/inserir"),
    onLineClick: (id) => history.push(`/app/cfe-instituicoes/editar/${id.id}`),
    columns: [
      {
        label: "Nome fantasia",
        name: "nomeFantasia",
      },
      {
        label: "Razão social",
        name: "razaoSocial",
      },
      {
        label: "CNPJ",
        name: "CNPJ",
      },
    ],
    array: instituicoes,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
